import './App.css';
import { BrowserRouter, Route, Routes,Navigate } from "react-router-dom";
import Carrito from './components/carrito';
import ProductList from './components/ProductList';
import NavBar from './components/NavBar';
import Home from './components/Home';
import SocialMedia from './components/SocialMedia';
import { useState } from 'react'; // Importamos useState
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const categories = ['fruta', 'verdura', 'envasados', 'mayorista'];



  return (
      <BrowserRouter>
      <NavBar />
     

        <Routes>
          <Route path="/" element={<Navigate to="/products" />} />

          <Route path="/Nosotros" element={<Home />} />

          <Route path="/products" element={<ProductList categories={categories} />} />
          <Route path="/cart" element={<Carrito/>} /> {/* Pasamos el teléfono como prop */}
          <Route path="/contactUs" element={<Home />} />
          <Route path="/admin" element={<ProtectedRoute><ProductList categories={categories} admin={true} /></ProtectedRoute>} />
        </Routes>
          
        <SocialMedia />
      </BrowserRouter>
  );
}

export default App;